import React from 'react';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import EventNoteIcon from '@mui/icons-material/EventNote';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import StorefrontIcon from '@mui/icons-material/Storefront';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import WidgetsIcon from '@mui/icons-material/Widgets';
import { isPathAllowed } from '../../../config/moduleAccess';
import { AdminPermissionsMap, isPathAllowedForSubAdmin } from '../../users/adminModuleMap';

export type ReportCategoryId = 'sales' | 'finance' | 'stock' | 'other';

export interface ReportCategory {
  id: ReportCategoryId;
  icon: React.ReactNode;
  color: string;
}

export interface ReportDefinition {
  id: string;
  path: string;
  category: ReportCategoryId;
  icon: React.ReactNode;
  color: string;
}

export const REPORT_CATEGORIES: ReportCategory[] = [
  { id: 'sales', icon: <StorefrontIcon />, color: '#4CAF50' },
  { id: 'finance', icon: <AccountBalanceWalletIcon />, color: '#3F51B5' },
  { id: 'stock', icon: <Inventory2Icon />, color: '#FF9800' },
  { id: 'other', icon: <WidgetsIcon />, color: '#607D8B' },
];

export const REPORTS: ReportDefinition[] = [
  { id: 'endOfDay', path: '/gun-sonu', category: 'sales', icon: <PointOfSaleIcon />, color: '#4CAF50' },
  { id: 'endOfDayList', path: '/gun-sonlari', category: 'sales', icon: <EventNoteIcon />, color: '#2196F3' },
  { id: 'restaurantOrders', path: '/restaurant-orders', category: 'sales', icon: <RestaurantIcon />, color: '#FF9800' },
  { id: 'allOrders', path: '/tum-siparisler', category: 'sales', icon: <LocalShippingIcon />, color: '#009688' },

  { id: 'profitLoss', path: '/kar-zarar', category: 'finance', icon: <AssessmentIcon />, color: '#9C27B0' },
  { id: 'invoiceReports', path: '/fatura/raporlar', category: 'finance', icon: <DescriptionIcon />, color: '#2196F3' },
  { id: 'accountMovements', path: '/cari-hareket-raporu', category: 'finance', icon: <PersonIcon />, color: '#3F51B5' },
  { id: 'cashMovements', path: '/accounting/cashbox/transactions', category: 'finance', icon: <LocalAtmIcon />, color: '#4CAF50' },
  { id: 'bankTransactions', path: '/bank/transactions', category: 'finance', icon: <AccountBalanceIcon />, color: '#00838F' },
  { id: 'loanPayments', path: '/kredi-odemeleri', category: 'finance', icon: <RequestQuoteIcon />, color: '#F44336' },

  { id: 'stockMovements', path: '/stok-hareket-raporu', category: 'stock', icon: <InventoryIcon />, color: '#FF9800' },
  { id: 'priceChangeLogs', path: '/fiyat-degisim-loglari', category: 'stock', icon: <LocalOfferIcon />, color: '#9C27B0' },
  { id: 'wmsReports', path: '/wms/raporlar', category: 'stock', icon: <WarehouseIcon />, color: '#009688' },

  { id: 'taskReports', path: '/reports', category: 'other', icon: <AssignmentIcon />, color: '#2196F3' },
  { id: 'mailReports', path: '/accounting/mail-raporlari', category: 'other', icon: <MarkEmailReadIcon />, color: '#607D8B' },
];

export const EXPENSE_CATEGORIES_PATH = '/gider-turleri';

export interface ReportAccessContext {
  enabledModules: string[] | null | undefined;
  isSubAdmin: boolean;
  adminPanelPermissions: AdminPermissionsMap | null | undefined;
}

export const canAccessReportPath = (path: string, ctx: ReportAccessContext): boolean =>
  isPathAllowed(path, ctx.enabledModules) &&
  (!ctx.isSubAdmin || isPathAllowedForSubAdmin(ctx.adminPanelPermissions, path));

export const getAccessibleReports = (ctx: ReportAccessContext): ReportDefinition[] =>
  REPORTS.filter(r => canAccessReportPath(r.path, ctx));
